
import { PropType } from 'vue'
import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'

export default {
    name: 'LogItem',
    components: { LogTemplate },
    props: {
        log: {
            type: Object as PropType<Log>,
            required: true,
        },
    },
    computed: {
        customString() {
            switch (this.log.logEventName) {
                case 'invalidCardCheckIn':
                    return this.log.accepted
                        ? `${this.log.logEventName}.isTrue(accepted)`
                        : `${this.log.logEventName}.isFalse(accepted)`
                default:
                    return this.log.logEventName
            }
        },
    },
}
